import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/Index';

Vue.use(VueRouter)

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

const routes = [
    {
      path: '/',
      component:Index,
      redirect:'/home',
      meta: {
        page: 'Home',
        title: '信息学基地',
      },
      children:[
        {
          path: 'home',  //首页
          name: 'home',
          component: () => import('@/views/home'),
        },
        {
          path: 'question',  //题库
          name: 'question',
          component: () => import('@/views/question'),
        },
        {
          path: 'quesInfo',  //题目详情
          name: 'quesInfo',
          component: () => import('@/views/quesInfo'),
        },
        {
          path: 'quesStatus',  //题目状态
          name: 'quesStatus',
          component: () => import('@/views/quesStatus'),
        },
        {
          path: 'status', //状态
          name: 'status', //状态
          component: () => import('@/views/status'),
        },
        {
          path: 'statusInfo', //状态详情
          name: 'statusInfo', //状态详情
          component: () => import('@/views/statusInfo'),
        },
        {
          path: 'ranking',  //排名
          name: 'ranking',  //排名
          component: () => import('@/views/ranking'),
        },
        {
          path: 'match', //竞赛
          name: 'match', //竞赛
          component: () => import('@/views/match'),
        },
        {
          path: 'matchInfo', //竞赛详情
          name: 'matchInfo',
          component: () => import('@/views/matchInfo'),
          children: [
            { path: 'info', component: () => import('@/views/matchInfo/info'),hidden:false},
            { path: 'list', component: () => import('@/views/matchInfo/list'), hidden: true },
            { path: 'status', component: () => import('@/views/matchInfo/status'), hidden: true },
            { path: 'rank', component: () => import('@/views/matchInfo/rank'), hidden: true },
            { path: 'census', component: () => import('@/views/matchInfo/census'), hidden: true },
          ]
        },
        {
          path: 'test',  //测验
          name: 'test',  //测验
          component: () => import('@/views/test'),
        },
        {
          path: 'testInfo', //竞赛详情
          name: 'testInfo',
          component: () => import('@/views/testInfo'),
          children: [
            { path: 'testinfo', component: () => import('@/views/testInfo/testinfo'),hidden:false},
            { path: 'testlist', component: () => import('@/views/testInfo/testlist'), hidden: true },
          ]
        },
        {
          path: 'center',  //个人中心
          name: 'center',
          component: () => import('@/views/center'),
        },
        {
          path: 'uploadQues',  //上传题目
          name: 'uploadQues',
          component: () => import('@/views/uploadQues'),
        },
        {
          path: 'others',  //他人
          name: 'others',  //他人
          component: () => import('@/views/others'),
        },
        {
          path: 'preliminary',  //初赛
          name: 'preliminary',  //初赛
          component: () => import('@/views/preliminary'),
        },
      ]
    },
    
    {
      path: '*',
      name: 'PageNotFound',
      component: () => import('@/views/PageNotFound.vue'),
    },
  ];

  const router = new VueRouter({
    base: process.env.NODE_ENV === 'production' ? '/dist/' : '/', // 根据服务器根目录修改
    routes : routes,
    mode : "history"
  })
  export default router


// WEBPACK FOOTER //
// ./src/router/index.js